import {useQuery, type QueryClient} from "@tanstack/react-query";
import {i18n} from "../i18n";
import type {Lang} from "../language";
import type {FlatTranslations} from "./bundle";
import {loadProjectBundle} from "./bundle";

export type getProjectTranslations = (lang: Lang) => Promise<FlatTranslations>;

export const projectTranslationsKey = (project: string, lang: Lang) =>
    ["i18n", "project", project, lang] as const;

export function useProjectTranslationsFile(args: {
    project: string | null;
    lang: Lang;
    getProjectTranslations: getProjectTranslations;
    enabled?: boolean;
}) {
    const {project, lang, getProjectTranslations, enabled = true} = args;

    return useQuery({
        queryKey: project ? projectTranslationsKey(project, lang) : ["i18n", "project", "none", lang],
        enabled: enabled && !!project,
        staleTime: 5 * 60_000,
        queryFn: async () => {
            if (!project) throw new Error("project missing");
            return getProjectTranslations(lang);
        },

        select: (data) => {
            loadProjectBundle(i18n, lang, data);
            return data;
        },
    });
}

export function clearProjectQueries(queryClient: QueryClient) {
    queryClient.removeQueries({queryKey: ["i18n", "project"], exact: false});
}
